<template>
  <div v-if="isPC" class="slide-container">
    <!-- PC 画面: iframe を表示、スマホ画面：pdfのurlにリダイレクト -->
    <iframe :src="pdfUrl" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: "PdfViewer",
  data() {
    return {
      pdfUrl: process.env.VUE_APP_S3_PDF, // S3 の PDF URL
      isPC: true, // PC 表示かどうかを判定
    };
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkDeviceType();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // 1. モバイルデバイス（スマホまたはタブレット）の判定
      const isMobileDevice = /android|iphone|ipad|ipod|blackberry|windows phone|opera mini|iemobile/i.test(userAgent);

      if (isMobileDevice) {
        this.isPC = false;
        window.location.href = this.pdfUrl; // モバイルデバイスの場合、リダイレクト
        return;
      }

      // 2. デバイスが判定できない場合、画面サイズで判定
      this.checkScreenSize();
    },
    checkScreenSize() {
      // 画面幅が 1024px 以下の場合はモバイルと判定
      if (window.innerWidth <= 1024) {
        this.isPC = false;
        window.location.href = this.pdfUrl; // モバイルデバイスの場合、リダイレクト
      } else {
        this.isPC = true; // PC 表示
      }
    },
  },
};
</script>


<style scoped>
.slide-container {
  position: relative;
  margin-top: 133px;
  margin-bottom: 3%;
  width: 90%;
  max-width: 1300px;
  align-self: center;
  display: flex;
  justify-content: center;
}
.slide-container iframe {
  border: 1px solid #ddd;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width:90%;
  height: 75vh;
  max-height: 800px;
}
</style>